import React from "react";

const ConvoNavBar = () => {
    return (
        <div
            style={{
                padding: "12px 16px",
                backgroundColor: "#f8fafc",
                borderBottom: "1px solid #e2e8f0",
                textAlign: "center",
                fontSize: "14px",
                fontWeight: 500,
                color: "#64748b",
            }}
        >
            WhatsApp Conversation
        </div>
    );
};

export default ConvoNavBar;
